import {gql} from '@apollo/client'

export const STREAM_CONTAINER_DETAIL = gql`
  fragment StreamContainerDetail on StreamContainer {
    id
    created
    updated
    environmentId
    streamId
    enabled
    name
    isDefault
    cardLimit
    filter
    stream: environmentStream {
      name
    }
    themeId
    theme: environmentTheme {
      name
    }
    darkThemeId
    darkTheme: environmentDarkTheme {
      name
    }
  }
`

export const STREAM_CONTAINER_LIST = gql`
  query StreamContainerList(
    $environmentId: String!
    $orderBy: [StreamContainersOrderBy!]! = [UPDATED_DESC]
  ) {
    streamContainers(
      orderBy: $orderBy
      condition: {environmentId: $environmentId}
    ) {
      nodes {
        ...StreamContainerDetail
      }
      totalCount
    }
  }
  ${STREAM_CONTAINER_DETAIL}
`

export const GET_STREAM_CONTAINER = gql`
  query GetStreamContainer($id: String!, $environmentId: String!) {
    streamContainer(id: $id, environmentId: $environmentId) {
      ...StreamContainerDetail
    }
  }
  ${STREAM_CONTAINER_DETAIL}
`

export const ADD_STREAM_CONTAINER = gql`
  mutation AddStreamContainer(
    $environmentId: String!
    $name: String!
    $streamId: String!
    $themeId: String!
    $darkThemeId: String
    $cardLimit: Int
    $filter: [JSON]
  ) {
    createStreamContainer(
      input: {
        streamContainer: {
          name: $name
          environmentId: $environmentId
          streamId: $streamId
          themeId: $themeId
          darkThemeId: $darkThemeId
          cardLimit: $cardLimit
          filter: $filter
        }
      }
    ) {
      streamContainer {
        ...StreamContainerDetail
      }
    }
  }
  ${STREAM_CONTAINER_DETAIL}
`

export const EDIT_STREAM_CONTAINER = gql`
  mutation EditStreamContainer(
    $id: String!
    $environmentId: String!
    $name: String
    $streamId: String
    $themeId: String
    $darkThemeId: String
    $enabled: Boolean
    $cardLimit: Int
    $filter: [JSON]
  ) {
    updateStreamContainer(
      input: {
        id: $id
        environmentId: $environmentId
        patch: {
          name: $name
          streamId: $streamId
          themeId: $themeId
          darkThemeId: $darkThemeId
          enabled: $enabled
          cardLimit: $cardLimit
          filter: $filter
        }
      }
    ) {
      streamContainer {
        ...StreamContainerDetail
      }
    }
  }
  ${STREAM_CONTAINER_DETAIL}
`

export const DELETE_STREAM_CONTAINER = gql`
  mutation DeleteStreamContainer($id: String!, $environmentId: String!) {
    deleteStreamContainer(input: {id: $id, environmentId: $environmentId}) {
      streamContainer {
        ...StreamContainerDetail
      }
    }
  }
  ${STREAM_CONTAINER_DETAIL}
`

export const SET_STREAM_CONTAINER_TO_DEFAULT = gql`
  mutation setDefaultStreamContainer(
    $environmentId: String!
    $streamContainerId: String!
  ) {
    setDefaultStreamContainer(
      input: {
        environmentId: $environmentId
        streamContainerId: $streamContainerId
      }
    ) {
      streamContainers {
        ...StreamContainerDetail
      }
    }
  }
`
